/**
 * @author        esraa.afifi@zumper.com (Esraa Afifi)
 * @copyright     Copyright (c) 2023, Zumper
 * @description   getBoxFromBounds
 */

import polyline from '@mapbox/polyline'
import { isValidBounds } from '@zcode/nr-utils'
import type { MNeighborhood } from '@zcode/state-type'
import type { ReadonlyDeep } from 'type-fest'

type NestedCoordinateArray = ReadonlyDeep<
  GeoJSON.Polygon['coordinates'] | GeoJSON.MultiPolygon['coordinates']
>

export const getBoxFromBounds = (hood: MNeighborhood | undefined) => {
  let dataJson: number[][] = []
  if (hood?.encodedBounds && hood?.encodedBounds?.length > 0) {
    dataJson = polyline.toGeoJSON(hood?.encodedBounds?.[0]?.exterior).coordinates
  }
  const longitudes: number[] = []
  const latitudes: number[] = []
  dataJson?.forEach((entry: number[]) => {
    longitudes.push(entry[0])
    latitudes.push(entry[1])
  })
  const minLat = Math.min(...latitudes)
  const minLng = Math.min(...longitudes)
  const maxLat = Math.max(...latitudes)
  const maxLng = Math.max(...longitudes)

  const box = {
    maxLng,
    minLng,
    maxLat,
    minLat,
  }
  if (isValidBounds(box)) {
    return box
  }
}

const extractLatAndLng = (coordinates: readonly any[]): [number[], number[]] => {
  const latitudes: number[] = []
  const longitudes: number[] = []

  const stack: any[] = [...coordinates]

  while (stack.length > 0) {
    const item = stack.pop()

    if (Array.isArray(item)) {
      if (item.length === 2 && typeof item[0] === 'number' && typeof item[1] === 'number') {
        longitudes.push(item[0])
        latitudes.push(item[1])
      } else {
        stack.push(...item)
      }
    }
  }
  return [latitudes, longitudes]
}

// export const getCityBoxFromBounds = (city: MCity) => {
export const getCityBoxFromBounds = (bounds: NestedCoordinateArray) => {
  const [latitudes, longitudes] = extractLatAndLng(bounds)
  const minLat = Math.min(...latitudes)
  const minLng = Math.min(...longitudes)
  const maxLat = Math.max(...latitudes)
  const maxLng = Math.max(...longitudes)
  const box = {
    maxLng,
    minLng,
    maxLat,
    minLat,
  }
  if (isValidBounds(box)) {
    return box
  }
}
